import { FunctionComponent } from 'react';
import { Link } from 'react-router';
import { PropertyAssociationInfo } from '../models/PropertyAssociationInfo';
import { formatCompanyRegistrationNumber } from '../propertyAssociationUtils';

type Props = {
    value: PropertyAssociationInfo;
};

const BASE_CLASS_NAME = 'boxlist__item boxlist__item--slim boxlist__item--no-image';

const PropertyAssociationItem: FunctionComponent<Props> = ({ value }) => {
    const className = getClassName(value);

    return (
        <div className={className}>
            <Link to={`${value.propertyAssociationId}/areas`} className="boxlist__item-link">
                {value.name}
            </Link>

            <div className="boxlist__item-meta my-0 pe-none small">
                <span>{value.accountId || 'Kundnummer saknas'}</span> <span className="opacity-25">|</span> <span>{formatCompanyRegistrationNumber(value.companyRegistrationNumber)}</span>
            </div>

            {value.areas && value.areas.length > 0 && (
                <dl className="clearfix boxlist__item-details mb-0">
                    <dt className="small fw-normal mb-1">Områden/Fastigheter:</dt>
                    {value.areas &&
                        value.areas.map((area) => (
                            <dd key={area.propertyAssociationAreaId} className="float-start me-1 mb-1">
                                <Link to={`${value.propertyAssociationId}/areas/${area.propertyAssociationAreaId}`} className="badge bg-secondary-subtle fw-normal">
                                    {area.name}
                                </Link>
                            </dd>
                        ))}
                </dl>
            )}
        </div>
    );
};

function getClassName(propertyAssociation: PropertyAssociationInfo) {
    const { endDate, isTrialSubscription } = propertyAssociation;

    if (endDate === null) {
        return `${BASE_CLASS_NAME} boxlist__item--valid`;
    }

    if (new Date(endDate) < new Date()) {
        return `${BASE_CLASS_NAME} boxlist__item--invalid`;
    }

    if (isTrialSubscription) {
        return `${BASE_CLASS_NAME} boxlist__item--trial`;
    }

    return `${BASE_CLASS_NAME} boxlist__item--warning`;
}

export default PropertyAssociationItem;
